import { FC, useState } from 'react'

import { EuiButton, EuiFieldText, EuiFlexGroup, EuiFlexItem, EuiFlyoutBody, EuiFlyoutFooter, EuiFlyoutHeader, EuiFormRow, EuiTitle } from '@elastic/eui'
import AcFlyout from 'components/AcFlyout'

import BlueprintEditWarning from 'features/planner/components/BlueprintEditWarning'

interface EditTitleFlyoutProps {
  currentTitle: string
  onSave: (newTitle: string) => void
  onClose: () => void
  isSaving?: boolean
  showBlueprintWarning?: boolean
}

const EditTitleFlyout: FC<EditTitleFlyoutProps> = ({ currentTitle, onSave, onClose, isSaving = false, showBlueprintWarning = false }) => {
  const [title, setTitle] = useState(currentTitle)

  const handleSave = () => {
    if (title.trim()) {
      onSave(title.trim())
    }
  }

  const hasChanged = title.trim() !== currentTitle

  return (
    <AcFlyout onClose={onClose} size="s" ownFocus>
      <EuiFlyoutHeader hasBorder>
        <EuiTitle size="m">
          <h2>Edit Title</h2>
        </EuiTitle>
      </EuiFlyoutHeader>

      <EuiFlyoutBody>
        <BlueprintEditWarning show={showBlueprintWarning} />
        <EuiFormRow label="Title" fullWidth>
          <EuiFieldText
            fullWidth
            value={title}
            onChange={e => setTitle(e.target.value)}
            disabled={isSaving}
          />
        </EuiFormRow>
      </EuiFlyoutBody>

      <EuiFlyoutFooter>
        <EuiFlexGroup direction='row' alignItems='center'>
          <EuiFlexItem grow={false}>
            <EuiButton onClick={onClose} disabled={isSaving}>Cancel</EuiButton>
          </EuiFlexItem>
          <EuiFlexItem grow={false}>
            <EuiButton onClick={handleSave} fill disabled={!title.trim() || !hasChanged || isSaving} isLoading={isSaving}>
              Save
            </EuiButton>
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlyoutFooter>
    </AcFlyout>
  )
}

export default EditTitleFlyout
